import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getCurrentVariant } from '../../../../../helpers/getCurrentVariant';
import { getProductType } from '../../../../../helpers/getProductType';

interface VenetianBlindsProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const VenetianBlinds63 = ({
  patternUrl,
  ...props
}: VenetianBlindsProps) => {
  const [state] = useService(productBuilderMachine);

  const currentVariant = getCurrentVariant(state.context);

  const currentProduct = currentVariant
    ? state.context.products.find(product =>
        product.variants.find(variant => variant.id === currentVariant.id),
      )
    : '';

  const bottomAndTopRailHex = currentProduct
    ? currentProduct.tags
        .find(tag => tag.includes('Hex Code'))
        ?.replace('Hex Code: ', '')
    : '';
  const subProductType = getProductType(state.context);

  const valance =
    typeof state.context.custom.venetianValance === 'number' ? 'Yes' : '';

  if (
    valance !== 'Yes' &&
    subProductType &&
    !subProductType.includes('Timber')
  ) {
    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.21 415"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="venetianBlind63"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1"
            x1={276.6}
            y1={40.72}
            x2={276.6}
            y2={23.53}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-2"
            x1={276.6}
            y1={65.58}
            x2={276.6}
            y2={48.38}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-3"
            x1={276.6}
            y1={90.43}
            x2={276.6}
            y2={73.23}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-4"
            x1={276.6}
            y1={115.28}
            x2={276.6}
            y2={98.08}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-5"
            x1={276.6}
            y1={140.13}
            x2={276.6}
            y2={122.93}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-6"
            x1={276.6}
            y1={164.98}
            x2={276.6}
            y2={147.79}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-7"
            x1={277.61}
            y1={214.69}
            x2={277.61}
            y2={197.49}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-8"
            x1={277.61}
            y1={239.54}
            x2={277.61}
            y2={222.34}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-9"
            x1={277.61}
            y1={189.84}
            x2={277.61}
            y2={172.64}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <style>
            {'.prefix__cls-3{fill:none;stroke:gray;stroke-miterlimit:10}'}
          </style>
        </defs>
        <path
          d="M554.21 18.06V0H0v18.06h91.37v5.47H14.5L6.22 40.72h85.15v7.66H14.5L6.22 65.57h85.15v7.66H14.5l-8.28 17.2h85.15v7.65H14.5l-8.28 17.2h85.15v7.65H14.5l-8.28 17.2h85.15v7.66H14.5L6.22 165h85.15v7.66H15.5l-8.28 17.2h84.15v7.65H15.5l-8.28 17.2h84.15v7.65H15.5l-8.28 17.2h84.15v6.83H5v13.26h82.84a2.09 2.09 0 100 4.17h8.07a2.09 2.09 0 000-4.17h177.24a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 000-4.17H458.8a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 100-4.17h82.34v-13.28h-85.87v-6.83H548l-8.27-17.2h-76.39v-7.65H548l-8.27-17.2h-76.39v-7.65H548l-8.27-17.2h-76.39V165H547l-8.28-17.19h-75.38v-7.66H547l-8.28-17.2h-75.38v-7.65H547l-8.28-17.2h-75.38v-7.67H547l-8.28-17.2h-75.38v-7.66H547l-8.28-17.19h-75.38v-7.66H547l-8.28-17.19h-75.38v-5.47zm-277.6 22.66v7.66H98.49v-7.66zM98.49 23.53v-5.47h178.12v5.47zm178.12 42v7.66H98.49v-7.62zm0 24.86v7.65H98.49v-7.61zm0 24.85v7.65H98.49v-7.65zm0 24.85v7.66H98.49v-7.66zm0 24.85v7.66H98.49V165zm0 24.86v7.65H98.49v-7.65zm0 24.85v7.65H98.49v-7.65zm0 24.85v6.83H98.49v-6.83zm1 0h177.17v6.83H277.61zm0-17.2v-7.65h177.17v7.65zm0-24.85v-7.65h177.17v7.65zm0-24.85V165h177.17v7.66zm0-24.85v-7.66h177.17v7.66zm0-24.86v-7.65h177.17v7.65zm0-24.85v-7.61h177.17v7.65zm0-24.85v-7.62h177.17v7.66zm0-24.85v-7.62h177.17v7.66zm0-24.85v-5.43h177.17v5.47zM92.37 18.06h5.12v5.47h-5.12zm0 22.66h5.12v7.66h-5.12zm0 24.85h5.12v7.66h-5.12zm0 24.86h5.12v7.65h-5.12zm0 24.85h5.12v7.65h-5.12zm0 24.85h5.12v7.66h-5.12zm0 24.85h5.12v7.66h-5.12zm0 24.86h5.12v7.65h-5.12zm0 24.85h5.12v7.65h-5.12zm0 24.85h5.12v6.83h-5.12zm370 6.83h-6.56v-6.83h6.56zm0-24h-6.56v-7.65h6.56zm0-24.85h-6.56v-7.65h6.56zm0-24.85h-6.56V165h6.56zm0-24.85h-6.56v-7.66h6.56zm0-24.86h-6.56v-7.65h6.56zm0-24.85h-6.56v-7.68h6.56zm0-24.85h-6.56v-7.69h6.56zm0-24.85h-6.56v-7.69h6.56zm0-24.85h-6.56v-5.5h6.56z"
          fill="url(#venetianBlind63)"
        />
        <g opacity={0.25}>
          <path
            className="prefix__cls-3"
            d="M277.13 17.97v241.57M462.87 17.97v241.57M455.28 17.97v5.56M455.28 40.72v7.66M455.28 65.58v7.65M455.28 90.43v7.65M455.28 115.28v7.65M455.28 140.13v7.66M455.28 164.98v7.66M455.28 189.84v7.65M455.28 214.69v7.65M455.28 239.54v6.83M97.99 17.97v5.56M97.99 40.72v7.66M97.99 65.58v7.65M97.99 90.43v7.65M97.99 115.28v7.65M97.99 140.13v7.66M97.99 164.98v7.66M97.99 189.84v7.65M97.99 214.69v7.65M97.99 239.54v6.83M91.9 17.97v241.57"
          />
        </g>
        <path
          fill="url(#prefix__New_Gradient_Swatch_1)"
          d="M546.99 40.72H6.21l8.29-17.19h524.21l8.28 17.19z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-2)"
          d="M546.99 65.58H6.21l8.29-17.2h524.21l8.28 17.2z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-3)"
          d="M546.99 90.43H6.21l8.29-17.2h524.21l8.28 17.2z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-4)"
          d="M546.99 115.28H6.21l8.29-17.2h524.21l8.28 17.2z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-5)"
          d="M546.99 140.13H6.21l8.29-17.19h524.21l8.28 17.19z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-6)"
          d="M546.99 164.98H6.21l8.29-17.19h524.21l8.28 17.19z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-7)"
          d="M547.99 214.69H7.22l8.28-17.2h524.22l8.27 17.2z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-8)"
          d="M539.72 222.34H15.5l-8.28 17.2h540.77l-8.27-17.2z"
        />
        <path
          fill="url(#prefix__New_Gradient_Swatch_1-9)"
          d="M539.72 172.64H15.5l-8.28 17.2h540.77l-8.27-17.2z"
        />
      </svg>
    );
  } else if (
    valance === 'Yes' &&
    subProductType &&
    !subProductType.includes('Timber')
  ) {
    return (
      <svg
        data-name="Layer 1"
        viewBox="0 0 554.21 415"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="venetianBlind63"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__a"
            x1={277.03}
            y1={40.71}
            x2={277.03}
            y2={25.75}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__b"
            x1={277.03}
            y1={65.56}
            x2={277.03}
            y2={48.37}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__c"
            x1={277.03}
            y1={90.41}
            x2={277.03}
            y2={73.22}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__d"
            x1={277.03}
            y1={115.27}
            x2={277.03}
            y2={98.07}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__e"
            x1={277.03}
            y1={140.12}
            x2={277.03}
            y2={122.92}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__f"
            x1={277.03}
            y1={164.97}
            x2={277.03}
            y2={147.77}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__g"
            x1={278.04}
            y1={214.67}
            x2={278.04}
            y2={197.48}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__h"
            x1={278.04}
            y1={239.53}
            x2={278.04}
            y2={222.33}
            xlinkHref="#prefix__a"
          />
          <linearGradient
            id="prefix__i"
            x1={278.04}
            y1={189.82}
            x2={278.04}
            y2={172.63}
            xlinkHref="#prefix__a"
          />
        </defs>
        <path
          d="M554.21 0H0v25.75h13.83l-7.21 15h85.16v7.66H14.91L6.62 65.57h85.16v7.66H14.91l-8.29 17.2h85.16v7.65H14.91l-8.29 17.2h85.16v7.65H14.91l-8.29 17.2h85.16v7.66H14.91L6.62 165h85.16v7.66H15.91l-8.28 17.2h84.15v7.65H15.91l-8.28 17.2h84.15v7.65H15.91l-8.28 17.2h84.15v6.83H5.41v13.26h82.83a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 100-4.17h177.24a2.09 2.09 0 100 4.17h8.07a2.09 2.09 0 000-4.17h177.59a2.09 2.09 0 100 4.17h8.07a2.09 2.09 0 000-4.17h82.34v-13.28h-85.88v-6.83h84.66l-8.28-17.2h-76.38v-7.65h84.66l-8.28-17.2h-76.38v-7.65h84.66l-8.28-17.2h-76.38V165h83.65l-8.27-17.19h-75.38v-7.66h83.65l-8.27-17.2h-75.38v-7.65h83.65l-8.27-17.2h-75.38v-7.67h83.65l-8.27-17.2h-75.38v-7.66h83.65l-8.27-17.19h-75.38v-7.66h83.65l-7.2-15h14zM97.9 246.37h-5.12v-6.83h5.12zm0-24h-5.12v-7.65h5.12zm0-24.85h-5.12v-7.65h5.12zm0-24.85h-5.12V165h5.12zm0-24.85h-5.12v-7.66h5.12zm0-24.86h-5.12v-7.65h5.12zm0-24.85h-5.12v-7.68h5.12zm0-24.85h-5.12v-7.69h5.12zm0-24.85h-5.12v-7.69h5.12zM277 246.37H98.9v-6.83H277zm0-24H98.9v-7.65H277zm0-24.85H98.9v-7.65H277zm0-24.85H98.9V165H277zm0-24.85H98.9v-7.66H277zm0-24.86H98.9v-7.65H277zm0-24.85H98.9v-7.68H277zm0-24.85H98.9v-7.69H277zm0-24.85H98.9v-7.69H277zm178.17 198H278v-6.83h177.18zm0-24H278v-7.65h177.18zm0-24.85H278v-7.65h177.18zm0-24.85H278V165h177.18zm0-24.85H278v-7.66h177.18zm0-24.86H278v-7.65h177.18zm0-24.85H278v-7.72h177.18zm0-24.85H278v-7.73h177.18zm0-24.85H278v-7.73h177.18zm7.56 198h-6.56v-6.83h6.56zm0-24h-6.56v-7.65h6.56zm0-24.85h-6.56v-7.65h6.56zm0-24.85h-6.56V165h6.56zm0-24.85h-6.56v-7.66h6.56zm0-24.86h-6.56v-7.65h6.56zm0-24.85h-6.56v-7.76h6.56zm0-24.85h-6.56v-7.77h6.56zm0-24.85h-6.56v-7.77h6.56z"
          fill="url(#venetianBlind63)"
        />
        <path
          fill="url(#prefix__a)"
          d="M13.85 25.75L6.64 40.71h540.78l-7.2-14.96H13.85z"
        />
        <path
          fill="url(#prefix__b)"
          d="M547.42 65.56H6.64l8.29-17.19h524.21l8.28 17.19z"
        />
        <path
          fill="url(#prefix__c)"
          d="M547.42 90.41H6.64l8.29-17.19h524.21l8.28 17.19z"
        />
        <path
          fill="url(#prefix__d)"
          d="M547.42 115.27H6.64l8.29-17.2h524.21l8.28 17.2z"
        />
        <path
          fill="url(#prefix__e)"
          d="M547.42 140.12H6.64l8.29-17.2h524.21l8.28 17.2z"
        />
        <path
          fill="url(#prefix__f)"
          d="M547.42 164.97H6.64l8.29-17.2h524.21l8.28 17.2z"
        />
        <path
          fill="url(#prefix__g)"
          d="M548.42 214.68H7.65l8.28-17.2h524.22l8.27 17.2z"
        />
        <path
          fill="url(#prefix__h)"
          d="M540.15 222.33H15.93l-8.28 17.2h540.77l-8.27-17.2z"
        />
        <path
          fill="url(#prefix__i)"
          d="M540.15 172.63H15.93l-8.28 17.19h540.77l-8.27-17.19z"
        />
      </svg>
    );
  } else if (
    valance !== 'Yes' &&
    subProductType &&
    subProductType.includes('Timber')
  ) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.21 415"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="venetianBlind63"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={277.1}
            y1={35.72}
            x2={277.1}
            y2={18.53}
            gradientTransform="translate(0 5)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-2"
            x1={277.1}
            y1={60.58}
            x2={277.1}
            y2={43.38}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-3"
            x1={277.1}
            y1={85.43}
            x2={277.1}
            y2={68.23}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-4"
            x1={277.1}
            y1={110.28}
            x2={277.1}
            y2={93.08}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-5"
            x1={277.1}
            y1={135.13}
            x2={277.1}
            y2={117.94}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-6"
            x1={277.1}
            y1={159.98}
            x2={277.1}
            y2={142.79}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-7"
            x1={278.1}
            y1={209.69}
            x2={278.1}
            y2={192.49}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-8"
            x1={278.1}
            y1={234.54}
            x2={278.1}
            y2={217.34}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-9"
            x1={278.1}
            y1={184.84}
            x2={278.1}
            y2={167.64}
            xlinkHref="#prefix__linear-gradient"
          />
          <style>
            {'.prefix__cls-3{fill:none;stroke:gray;stroke-miterlimit:10}'}
          </style>
        </defs>
        <path
          className="prefix__separate"
          fill={bottomAndTopRailHex}
          d="M0 0h554.21v18.06H0z"
        />
        <path
          d="M549.21 246.37H278.1v-6.87h177.17v6.87h1v-6.83h6.56v6.83h.47v-6.83H548l-8.27-17.2h-76.4v-7.65H548l-8.27-17.2h-76.4v-7.65H548l-8.27-17.2h-76.4V165H547l-8.29-17.19h-75.38v-7.66H547L538.71 123h-75.38v-7.7H547l-8.29-17.2h-75.38v-7.67H547l-8.29-17.2h-75.38v-7.66H547l-8.29-17.19h-75.38v-7.66H547l-8.29-17.19h-75.38v-5.47h-.47v5.5h-6.56v-5.5h-1v5.47H278.13v-5.47h-1v5.47H99v-5.47h-1v5.47h-5.14v-5.47h-1.5v5.47H14.5L6.21 40.72h85.15v7.66H14.5L6.21 65.57h85.15v7.66H14.5l-8.29 17.2h85.15v7.65H14.5l-8.29 17.2h85.15v7.65H14.5l-8.29 17.2h85.15v7.66H14.5L6.21 165h85.15v7.66H15.5l-8.29 17.2h84.15v7.65H15.5l-8.29 17.2h84.15v7.65H15.5l-8.29 17.2h84.15v6.83H5v13.26h82.84a2.09 2.09 0 00-.29 4.17h8.36a2.09 2.09 0 000-4.17h177.24a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 000-4.17H458.8a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 00.29-4.17h82.05zM456.3 40.72h6.56v7.7h-6.56zm0 24.85h6.56v7.7h-6.56zm0 24.86h6.56v7.69h-6.56zm0 24.89h6.56V123h-6.56zm0 24.85h6.56v7.66h-6.56zm0 24.83h6.56v7.68h-6.56zm0 24.88h6.56v7.65h-6.56zm0 24.85h6.56v7.65h-6.56zm-1 7.57H278.1v-7.65h177.17zm0-24.85H278.1v-7.65h177.17zm0-24.79l-177.2-.06V165h177.17zm0-24.91H278.1v-7.66h177.17zm0-24.86H278.1v-7.65h177.17zm0-24.81L278.1 98v-7.57h177.17zM278.1 40.72h177.17v7.66H278.1zm0 24.85h177.17v7.66H278.1zM99 40.72h178.1v7.66H99zm0 24.85h178.11v7.62H99zm0 24.86h178.11V98H99zm0 24.81h178.1v7.65H99zm0 24.85h178.1v7.66H99zM99 165l178.11-.06v7.66H99zm0 24.8h178.1v7.65H99zm0 24.85h178.1v7.65H99zM92.86 40.72H98v7.66h-5.14zm0 24.85H98v7.66h-5.14zm0 24.86H98v7.65h-5.14zm0 24.85H98v7.65h-5.14zm0 24.85H98v7.66h-5.14zm0 24.87H98v7.64h-5.14zm0 24.84H98v7.65h-5.14zm0 24.85H98v7.65h-5.14zm0 31.7v-6.85H98v6.85zm6.14 0v-6.89h178.1v6.88H99z"
          fill="url(#venetianBlind63)"
        />
        <g id="prefix__Middle">
          <g opacity={0.25}>
            <path
              className="prefix__cls-3"
              d="M277.63 17.97v241.57M463.37 17.97v241.57M455.78 17.97v5.56M455.78 40.72v7.66M455.78 65.58v7.65M455.78 90.43v7.65M455.78 115.28v7.65M455.78 140.13v7.66M455.78 164.98v7.66M455.78 189.84v7.65M455.78 214.69v7.65M455.78 239.54v6.83M98.49 17.97v5.56M98.49 40.72v7.66M98.49 65.58v7.65M98.49 90.43v7.65M98.49 115.28v7.65M98.49 140.13v7.66M98.49 164.98v7.66M98.49 189.84v7.65M98.49 214.69v7.65M98.49 239.54v6.83M92.09 17.97v241.57"
            />
          </g>
          <path
            fill="url(#prefix__linear-gradient)"
            d="M547.49 40.72H6.71L15 23.53h524.21l8.28 17.19z"
          />
          <path
            fill="url(#prefix__linear-gradient-2)"
            d="M547.49 65.58H6.71L15 48.38h524.21l8.28 17.2z"
          />
          <path
            fill="url(#prefix__linear-gradient-3)"
            d="M547.49 90.43H6.71L15 73.23h524.21l8.28 17.2z"
          />
          <path
            fill="url(#prefix__linear-gradient-4)"
            d="M547.49 115.28H6.71L15 98.08h524.21l8.28 17.2z"
          />
          <path
            fill="url(#prefix__linear-gradient-5)"
            d="M547.49 140.13H6.71L15 122.94h524.21l8.28 17.19z"
          />
          <path
            fill="url(#prefix__linear-gradient-6)"
            d="M547.49 164.98H6.71L15 147.79h524.21l8.28 17.19z"
          />
          <path
            fill="url(#prefix__linear-gradient-7)"
            d="M548.49 214.69H7.72l8.28-17.2h524.22l8.27 17.2z"
          />
          <path
            fill="url(#prefix__linear-gradient-8)"
            d="M540.22 222.34H16l-8.28 17.2h540.77l-8.27-17.2z"
          />
          <path
            fill="url(#prefix__linear-gradient-9)"
            d="M540.22 172.64H16l-8.28 17.2h540.77l-8.27-17.2z"
          />
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 554.21 415"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="venetianBlind63"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={276.99}
            y1={643.63}
            x2={276.99}
            y2={626.44}
            gradientTransform="translate(0 -578)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-2"
            x1={276.99}
            y1={668.48}
            x2={276.99}
            y2={651.29}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-3"
            x1={276.99}
            y1={693.34}
            x2={276.99}
            y2={676.14}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-4"
            x1={276.99}
            y1={718.19}
            x2={276.99}
            y2={700.99}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-5"
            x1={276.99}
            y1={743.04}
            x2={276.99}
            y2={725.84}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-6"
            x1={278}
            y1={792.75}
            x2={278}
            y2={775.55}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-7"
            x1={278}
            y1={817.6}
            x2={278}
            y2={800.4}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-8"
            x1={278}
            y1={767.89}
            x2={278}
            y2={750.7}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-9"
            x1={276.99}
            y1={618.78}
            x2={276.99}
            y2={603.82}
            xlinkHref="#prefix__linear-gradient"
          />
          <style>
            {
              '.prefix__cls-1{fill:none}.prefix__cls-2{fill:#7391ff}.prefix__cls-12{opacity:.5;isolation:isolate}'
            }
          </style>
        </defs>
        <g id="prefix__Bottom">
          <path
            fill="url(#venetianBlind63)"
            d="M540.18 25.75H13.81l-1.6 3.33L6.6 40.75h85.16v7.66H14.89L6.6 65.57h85.16v7.66H14.89L6.6 90.43h85.16v7.65H14.89l-8.29 17.2h85.16v7.65H14.89l-8.29 17.2h85.16v7.66H14.89L6.6 165h85.16v7.66H15.89l-8.28 17.2h84.15v7.65H15.89l-8.28 17.2h84.15v7.65H15.89l-8.28 17.2h84.15v6.81h7.12v-6.79H277v6.78h1v-6.74h177.16v6.74h1v-6.7h6.56v6.7h1v-6.82h84.66l-8.28-17.2h-76.38v-7.65h84.66l-8.28-17.2h-76.38v-7.65h84.66l-8.28-17.2h-76.38V165h83.65l-8.27-17.19h-75.38v-7.66h83.65L539.1 123h-75.38v-7.7h83.65l-8.27-17.2h-75.38v-7.67h83.65l-8.27-17.2h-75.38v-7.66h83.65l-8.27-17.19h-75.38v-7.66h83.65l-5.55-11.55zM97.88 246.37h-5.12v-6.83h5.12zm0-24h-5.12v-7.65h5.12zm0-24.85h-5.12v-7.65h5.12zm0-24.85h-5.12V165h5.12zm0-24.85h-5.12v-7.66h5.12zm0-24.86h-5.12v-7.65h5.12zm0-24.85h-5.12v-7.68h5.12zm0-24.85h-5.12v-7.69h5.12zm0-24.85h-5.12v-7.69h5.12zm179.1 174H98.88v-7.65H277zm0-24.85H98.88v-7.65H277zm0-24.85H98.88V165H277zm0-24.85H98.88v-7.66H277zM277 123H98.88v-7.65H277zm0-24.85H98.88v-7.72H277zm0-24.85H98.88v-7.73H277zm0-24.85H98.88v-7.73H277zm178.17 174H278v-7.65h177.16zm0-24.85H278V190h177.16zm0-24.85H278V165h177.16zm0-24.85H278v-7.7h177.16zm0-24.86H278v-7.65h177.16zm0-24.85H278v-7.76h177.16zm0-24.85H278v-7.77h177.16zm0-24.85H278v-7.77h177.16zm7.56 174h-6.56v-7.69h6.56zm0-24.85h-6.56V190h6.56zm0-24.85h-6.56V165h6.56zm0-24.85h-6.56v-7.66h6.56zm0-24.86h-6.56v-7.65h6.56zm0-24.85h-6.56v-7.8h6.56zm0-24.85h-6.56v-7.81h6.56zm0-24.85h-6.56v-7.81h6.56z"
          />
        </g>
        <g id="prefix__Middle">
          <path
            fill="url(#venetianBlind63)"
            d="M462.31 246.51h-6.56v-.13h-1v.09H277.58v-.09h-1v.05H5v13.24h82.84-.08.06a2.15 2.15 0 00-1.14.43 2.09 2.09 0 001.16 3.72h8.07a2.05 2.05 0 002.21-1.92 2.09 2.09 0 00-1.94-2.23h.09-.07 177a2 2 0 00-.43 0h.41a2.08 2.08 0 10-.27 4.15h8.36a2 2 0 001.14-.43 2.09 2.09 0 00-1.16-3.72h.1-.08 177.54a2 2 0 00-.43 0h.41a2.08 2.08 0 10-.27 4.15h8.36a2 2 0 001.14-.43 2.09 2.09 0 00-1.16-3.72h.1-.08 82.32v-13.28h-86.89zM553.38 25.72h.38a187.86 187.86 0 000-25.11V0H.75a111.15 111.15 0 00-.26 23.21c.08.84.16 1.69.26 2.54h.35l11.13 3.33 1.6-3.33H540.2l1.64 3.42z"
          />
        </g>
        <g id="prefix__Top">
          <g id="prefix__Shadow">
            <path
              fill="url(#prefix__linear-gradient)"
              d="M547.38 65.63H6.61l8.28-17.19h524.22l8.27 17.19z"
            />
            <path
              fill="url(#prefix__linear-gradient-2)"
              d="M547.38 90.48H6.61l8.28-17.19h524.22l8.27 17.19z"
            />
            <path
              fill="url(#prefix__linear-gradient-3)"
              d="M547.38 115.34H6.61l8.28-17.2h524.22l8.27 17.2z"
            />
            <path
              fill="url(#prefix__linear-gradient-4)"
              d="M547.38 140.19H6.61l8.28-17.2h524.22l8.27 17.2z"
            />
            <path
              fill="url(#prefix__linear-gradient-5)"
              d="M547.38 165.04H6.61l8.28-17.2h524.22l8.27 17.2z"
            />
            <path
              fill="url(#prefix__linear-gradient-6)"
              d="M548.38 214.75H7.62l8.27-17.2h524.23l8.26 17.2z"
            />
            <path
              fill="url(#prefix__linear-gradient-7)"
              d="M540.12 222.4H15.89l-8.27 17.2h540.76l-8.26-17.2z"
            />
            <path
              fill="url(#prefix__linear-gradient-8)"
              d="M540.12 172.7H15.89l-8.27 17.19h540.76l-8.26-17.19z"
            />
            <path
              fill="url(#prefix__linear-gradient-9)"
              d="M13.81 25.82l-7.2 14.96h540.77l-7.2-14.96H13.81z"
            />
            <path
              className="prefix__cls-12"
              d="M553.23 25.84l-13.05-.02 1.62 3.41 11.43-3.39zM1.11 25.84l12.7-.02-1.61 3.33-11.09-3.31z"
            />
          </g>
        </g>
      </svg>
    );
  }
};
